import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function LoginPromptBar() {
  const location = useLocation();
  const loginPath = `/login?path=${encodeURIComponent(location.pathname)}`;

  return (
    <div className="login-prompt-bar" role="region" aria-label="Sign in prompt">
      <Link to={loginPath} className="login-prompt-bar__link">
        Click to login
      </Link>
      <span className="login-prompt-bar__hint"> to add items to your cart</span>
    </div>
  );
}
